webpackJsonp([264619699654045],{

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ProjectPage = __webpack_require__(9);
	
	var _ProjectPage2 = _interopRequireDefault(_ProjectPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var projectElements = {
		images: [{
			"src": "Parallelität/stadthalle",
			"orientation": "landscape"
		}, {
			"src": "Parallelität/matraze",
			"orientation": "landscape"
		}, {
			"src": "Parallelität/grafitti",
			"orientation": "landscape"
		}, {
			"src": "Parallelität/hecke",
			"orientation": "landscape"
		}, {
			"src": "Parallelität/netz",
			"orientation": "landscape"
		}, {
			"src": "Parallelität/hauswand",
			"orientation": "landscape"
		}, {
			"src": "Parallelität/feld",
			"orientation": "landscape"
		}, {
			"src": "Parallelität/gitter",
			"orientation": "landscape"
		}]
	};
	
	var Flat = function (_React$Component) {
		_inherits(Flat, _React$Component);
	
		function Flat() {
			_classCallCheck(this, Flat);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		Flat.prototype.render = function render() {
			return _react2.default.createElement(_ProjectPage2.default, {
				title: 'Parallelit\xE4t',
				text: 'Das Konzept dieser Fotoserie ist (wie auch dieser Text) sehr kurz und einfach: Flach erscheinende Sujets.',
				images: projectElements.images });
		};
	
		return Flat;
	}(_react2.default.Component);
	
	exports.default = Flat;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-flat-js-14c77950b260a0c3b150.js